<template>
	<section>
		<el-row class="container">
			<el-col :span="24">
				<el-col :span="4">
					<div>
						<span style="font-weight: bold;font-size: 1.17em;padding: 8px 0;display: block;">商家划拨查询</span>
					</div>
				</el-col>
			</el-col>
		</el-row>
		<el-row class="container">
		<!--工具条-->
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="filters">
					<el-form-item label="商家账号：">
						<el-input size="small" v-model="filters.account" clearable placeholder="输入商家账号查询"></el-input>
					</el-form-item>
					<el-form-item label="交易编号：">
						<el-input size="small" v-model="filters.order_id" clearable placeholder="输入交易编号"></el-input>
					</el-form-item>
					<el-form-item label="划拨时间：">
						<el-date-picker
								size="small"
								v-model="transTime"
								value-format="yyyy-MM-dd"
								type="daterange"
								align="right"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								:picker-options="pickerOptions">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" v-on:click="getTransferList">查询</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<!--列表-->
		<el-table
				:data="transferList"
				highlight-current-row
				:height="h"
				border
				v-loading="loading"
				@selection-change="selsChange"
				style="width: 100%;">
			<el-table-column type="index" width="60"></el-table-column>
			<el-table-column prop="nickname" label="账户昵称" min-width="150" ></el-table-column>
			<el-table-column prop="account" label="商家账号" min-width="100" ></el-table-column>
			<el-table-column prop="created_print" label="交易时间" width="150" sortable></el-table-column>
			<el-table-column prop="num" label="划拨数量" width="140" sortable></el-table-column>
			<el-table-column prop="current_balance" label="划拨后余额" width="140" sortable></el-table-column>
			<el-table-column prop="current_total_used" label="划拨时总使用量" width="145" sortable></el-table-column>
			<el-table-column prop="order_id" label="交易编号" width="190" ></el-table-column>
			<el-table-column prop="phone" label="手机号" width="120" ></el-table-column>

			<el-table-column label="操作" width="160">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">查询</el-button>
          <el-button size="small" @click="handleRevoke(scope.$index, scope.row)">撤单</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination layout="prev, pager, next, sizes, total"
					   @current-change="handleTransferCurrentChange"
					   @size-change="handleTransferSizeChange"
					   :page-size="20" :total="total"
					   style="float:right;">
		</el-pagination>
		<!--编辑界面-->
		<el-dialog title="商家详情" :visible.sync="merchantFormVisible">
			<el-form :model="merchantForm" label-width="90px" ref="merchantForm">
				<el-row>
					<el-col :span="6">
						<el-form-item label="账户昵称：">
							<span>{{merchantForm.nickname}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="账号:">
							<span>{{merchantForm.account}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="绑定手机:">
							<span>{{merchantForm.phone}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="注册日期:">
							<span>{{merchantForm.registered_print}}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="云豆余额：" prop="name">
							{{merchantForm.balance}}
							<span style="margin-left: 20px;margin-right: 10px;">云豆使用总量 </span>{{merchantForm.grand_total_used}}
							<span style="margin-left: 20px;margin-right: 10px;">云豆购买总量 </span>{{merchantForm.grand_total_purchase}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="4">
						<el-form-item label="所在地区：" prop="name">
							<el-input v-model="merchantForm.name" readonly auto-complete="off" disabled="disabled" ></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="街道地址：" prop="name">
							<el-input v-model="merchantForm.name" readonly auto-complete="off" disabled="disabled"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-row>
							<el-col :span="20">
								<h3 style="margin-top: 4px;">(云豆)使用详情列表</h3>
							</el-col>
							<el-col :span="4">
								<el-button size="mini" type="primary" v-on:click="handleUseExport">导出</el-button>
							</el-col>
						</el-row>

						<el-table
								:data="useList"
								id="useList"
								highlight-current-row
								:height="480"
								border
								v-loading="useLoading"
								@selection-change="selsChange"
								style="width: 100%;">
							<el-table-column prop="created_print" label="日期"></el-table-column>
							<el-table-column prop="num" label="使用数量" width="130"></el-table-column>
							<el-table-column prop="current_balance" label="使用后余额" width="130"></el-table-column>
							<el-table-column prop="current_total_used" label="使用后总使用量" width="130"></el-table-column>
						</el-table>
						<el-pagination layout="prev, pager, next, sizes, total"
									   @current-change="handleUseCurrentChange"
									   @size-change="handleUseSizeChange"
									   :page-size="useRows" :total="useTotal"
									   style="float:right;">
						</el-pagination>
					</el-col>
					<el-col :span="1">&nbsp;</el-col>
					<el-col :span="11">
						<el-row>
							<el-col :span="20">
								<h3 style="margin-top: 4px;">(云豆)购买详情列表</h3>
							</el-col>
							<el-col :span="4">
								<el-button size="mini" type="primary" v-on:click="handleBuyExport">导出</el-button>
							</el-col>
						</el-row>
						<el-table
								:data="buyList"
								id="buyList"
								highlight-current-row
								:height="480"
								border
								v-loading="buyLoading"
								@selection-change="selsChange"
								style="width: 100%;">
							<el-table-column prop="created_print" label="交易日期" min-width="140"></el-table-column>
							<el-table-column prop="num" label="购买数量" width="110"></el-table-column>
							<el-table-column prop="current_balance" label="购买后余额" width="110"></el-table-column>
							<el-table-column prop="order_id" label="交易编号" width="190"></el-table-column>
						</el-table>
						<el-pagination layout="prev, pager, next, sizes, total"
									   @current-change="handleBuyCurrentChange"
									   @size-change="handleBuySizeChange"
									   :page-size="buyRows" :total="buyTotal"
									   style="float:right;">
						</el-pagination>
					</el-col>
				</el-row>
			</el-form>
		</el-dialog>
		<!--撤单界面-->
		<el-dialog title="是否撤单" :visible.sync="revokeFormVisible" class="mini">
			<el-form :model="revokeForm" label-width="120px" ref="merchantForm">
        <el-form-item label="订单号" style="margin-bottom: 0px;">
          {{revokeForm.row.order_id}}
        </el-form-item>
        <el-form-item label="商家名称" style="margin-bottom: 0px;">
          {{revokeForm.row.nickname}}
        </el-form-item>
        <el-form-item label="划拨数量" style="margin-bottom: 0px;">
          {{revokeForm.row.num}}云豆
        </el-form-item>
        <el-form-item>
          <span style="color: #FF7F61">请先与客户沟通，再进行撤单操作</span><br>
        </el-form-item>
        <el-form-item label="请输入登录密码">
          <el-input style="width: 250px;"
                    size="small"
                    placeholder="登录密码"
                    show-password
                    v-model="revokeForm.password">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" v-on:click="submitRevoke" :disabled="!revokeForm.password">确认撤销</el-button>
        </el-form-item>
			</el-form>
		</el-dialog>
	</section>

</template>

<script>
	import util from '../../common/js/util'
	import XLSX from "xlsx";
	import FileSaver from "file-saver";
	//import NProgress from 'nprogress'

	export default {
		data() {
			return {
				filters: {
					account: '',
					order_id: ''
				},
				merchant:{},
				transTime:[],
				h:0,
				transferList:[],
				merchants: [],
				total: 0,
				page: 1,
				rows: 20,
				loading: false,
				listLoading: false,
				buyList:[],
				buyTotal: 0,
				buyPage: 1,
				buyRows:10,
				buyLoading: false,
				useList:[],
				useTotal: 0,
				usePage: 1,
				useRows:10,
				useLoading: false,
				merchantFormVisible: false,//编辑界面是否显示
				merchantForm:{},
        revokeFormVisible: false,//编辑界面是否显示
        revokeForm:{
          row: {}
        },
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
			}
		},
		beforeMount() {
			this.h = document.body.clientHeight - 61 - 200;
		},
		methods: {
			//性别显示转换
			formatSex: function (row, column) {
				return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
			},
			handleBuyExport(){
				if(this.buyList.length==0) return ;
				/* 从表生成工作簿对象 */
				let wb = XLSX.utils.table_to_book(document.querySelector("#buyList"));
				/* 获取二进制字符串作为输出 */
				let wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array"
				});
				try {
					FileSaver.saveAs(
							//Blob 对象表示一个不可变、原始数据的类文件对象。
							//Blob 表示的不一定是JavaScript原生格式的数据。
							//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
							//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
							new Blob([wbout], { type: "application/octet-stream" }),
							//设置导出文件名称
							"购买详情.xlsx"
					);
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout);
				}
				return wbout;
			},
			handleUseExport(){
				if(this.useList.length==0) return ;
				/* 从表生成工作簿对象 */
				let wb = XLSX.utils.table_to_book(document.querySelector("#useList"));
				/* 获取二进制字符串作为输出 */
				let wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array"
				});
				try {
					FileSaver.saveAs(
							//Blob 对象表示一个不可变、原始数据的类文件对象。
							//Blob 表示的不一定是JavaScript原生格式的数据。
							//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
							//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
							new Blob([wbout], { type: "application/octet-stream" }),
							//设置导出文件名称
							"使用详情.xlsx"
					);
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout);
				}
				return wbout;
			},
			handleTransferCurrentChange(val) {
				this.page = val;
				this.getTransferList();
			},
			handleTransferSizeChange(val){
				this.rows = val;
				this.getTransferList();
			},
			getTransferList() {
				let para = {
					page: this.page-1,
					rows: this.rows,
					account: this.filters.account,
					order_id: this.filters.order_id,
					start_time: this.transTime?this.transTime[0]:"",
					end_time: this.transTime?this.transTime[1]:""
				};
				this.loading = true;
				//NProgress.start();
				this.$Api.getTransferList(para).then((res) => {
					this.total = res.total;
					this.transferList = res.rows;
					this.loading = false;
					//NProgress.done();
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.merchantFormVisible = true;
				this.merchant = Object.assign({}, row);
				this.getBusinessInfo();

			},
      handleRevoke(index, row) {
        this.revokeFormVisible = true;
        this.revokeForm.row=row
        this.revokeForm.tips='撤销'+row.order_id+'（划拨到'+row.nickname+'，'+row.num+'云豆）'
      },
      submitRevoke() {
        let para = {
          password: this.revokeForm.password,
          order_id: this.revokeForm.row.order_id,
        };
        //NProgress.start();
        this.$Api.revokeTransfer(para).then((res) => {
          this.$message({
            message: '撤单成功',
            type: 'success'
          });
          this.getTransferList();
          this.revokeFormVisible=false
        })
        .catch(err => {
          this.$message({
            message: err,
            type: "error"
          });
        });
      },
			getBusinessInfo(){
				let para = {
					account: this.merchant.account,
				};
				//NProgress.start();
				this.$Api.getBusinessInfo(para).then((res) => {
					this.merchantForm = res;
					this.getUseRecordList(res.id_alias);
					this.getBuyRecordList(res.id_alias);
					//NProgress.done();
				})
				.catch(err => {
					this.$message({
						message: err,
						type: "error"
					});
				});
			},
			getUseRecordList(){
				console.log(this.merchant)
				let para = {
					page: this.usePage-1,
					rows: this.useRows,
					user_id: this.merchantForm.user_id
				};
				this.useLoading = true;
				//NProgress.start();
				this.$Api.getUseRecordList(para).then((res) => {
					this.useTotal = res.total;
					this.useList = res.rows;
					this.useLoading = false;
					//NProgress.done();
				})
				.catch(err => {
					this.useLoading = false;
					this.$message({
						message: err,
						type: "error"
					});
				});
			},
			getBuyRecordList(){
				let para = {
					page: this.buyPage-1,
					rows: this.buyRows,
					user_id: this.merchantForm.user_id
				};
				this.buyLoading = true;
				//NProgress.start();
				this.$Api.getBuyRecordList(para).then((res) => {
					this.buyTotal = res.total;
					this.buyList = res.rows;
					this.buyLoading = false;
					//NProgress.done();
				})
						.catch(err => {
							this.buyLoading = false;
							this.$message({
								message: err,
								type: "error"
							});
						});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			handleBuyCurrentChange(val){
				this.buyPage = val;
				this.getBuyRecordList();
			},
			handleBuySizeChange(val){
				this.buyRows = val;
				this.getBuyRecordList();
			},
			handleUseCurrentChange(val){
				this.usePage = val;
				this.getUseRecordList();
			},
			handleUseSizeChange(val){
				this.useRows = val;
				this.getUseRecordList();
			}
		},
		mounted() {
			this.getTransferList();
		}
	}

</script>

<style>
.mini .el-dialog{
  margin: 15vh auto 15vh auto!important;
  width: 500px!important;
  height: 400px!important;
}
</style>



// WEBPACK FOOTER //
// transferEnquiry.vue?a2384224